import { atom } from 'jotai';

const dealerNumberErrorAtom = atom<boolean>(false);

export { dealerNumberErrorAtom };
